import { Autocomplete, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultFornecedor } from "../../../../../../common/components/default_fornecedor_select";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultContrato } from "../../../../../../common/components/default_contratos_select";

type Props = {
  NMedicaoPesquisa: string;
  FornecedorPesquisa: number;
  ContratoPesquisa: number;
  centroDeCustoLista: { id: number; title: string }[];
  centroDeCusto: number[];
  StatusPesquisa: number;
  handleCentroDeCusto: (v: number[]) => void;
  onClearFilters: () => void;
  handleNMedicaoCampoChange: (value: string ) => void;
  handleFornecedorChange: (v: number) => void;
  handleContratoChange: (v: number) => void;
  handleStatusPesquisa: (v: number) => void,
};

export const Header = ({
  NMedicaoPesquisa,
  FornecedorPesquisa,
  ContratoPesquisa,
  StatusPesquisa,
  centroDeCusto,
  centroDeCustoLista,
  onClearFilters,
  handleNMedicaoCampoChange,
  handleCentroDeCusto,
  handleFornecedorChange,
  handleContratoChange,
  handleStatusPesquisa,
}: Props) => {

  return (
  <CascateList title="Filtros" defaultOpen>
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-end">
      
      {/* Nº Medição */}
      <div className="w-full">
        <DefaultInput
          label="Nº Medição"
          name="Nº Medição"
          value={NMedicaoPesquisa}
          onChangeValue={(e) => handleNMedicaoCampoChange(e)}
        />
      </div>

      {/* Centro de Custo */}
      <FormControl size="small" fullWidth>
        <Autocomplete
          size="small"
          multiple
          options={centroDeCustoLista}
          value={centroDeCustoLista.filter((i) => centroDeCusto.includes(i.id))}
          getOptionLabel={(i) => i.title}
          onChange={(_, newValue) => {
            handleCentroDeCusto(newValue.map((i) => i.id));
          }}
          isOptionEqualToValue={(opt, val) => opt.id === val.id}
          renderInput={(params) => (
            <TextField {...params} size="small" label="Centro de custo" />
          )}
        />
      </FormControl>

      {/* Fornecedor */}
      <div className="w-full">
        <DefaultFornecedor
          key={`forn-${FornecedorPesquisa}`}
          name="PesquisarFornecedor"
          value={FornecedorPesquisa || null}
          onChange={(valor) => handleFornecedorChange(Number(valor))}
          label="Fornecedor"
        />
      </div>

      {/* Contrato de Fornecedor */}
      <div className="w-full">
        <DefaultContrato
          key={`cont-${ContratoPesquisa}`}
          name="PesquisarContrato"
          value={ContratoPesquisa || null}
          onChange={(valor) => handleContratoChange(Number(valor))}
          label="Contrato"
        />
      </div>

      {/* Status */}
      <FormControl size="small" fullWidth>
        <InputLabel id="select-tempo-label" size="small">
          Status
        </InputLabel>
        <Select
          size="small"
          labelId="select-tempo-label"
          label="Status"
          value={StatusPesquisa}
          onChange={(event: SelectChangeEvent<number>) => {
            handleStatusPesquisa(event.target.value as number);
          }}
        >
          <MenuItem value={5}>Todas medições</MenuItem>
          <MenuItem value={1}>Finalizadas</MenuItem>
          <MenuItem value={2}>Em Elaboração</MenuItem>
          <MenuItem value={3}>Aprovadas</MenuItem>
          <MenuItem value={4}>Reprovadas</MenuItem>
        </Select>
      </FormControl>

      {/* Botão Limpar Filtros */}
      <div className="w-full">
        <PrimaryButton
          startIcon={
            <DynamicIcon
              nameIcon="ClearRounded"
              size={25}
              className="text-black"
            />
          }
          buttonColor="yellow"
          onClick={onClearFilters}
          fullWidth={true} 
        >
          Limpar filtros
        </PrimaryButton>
      </div>
      </div>
    </CascateList>
  );
};